import { useTheme } from '@/hooks/useTheme';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { THEME_OPTIONS } from './constant';
export function ThemeSelector() {
  const { theme, setTheme } = useTheme();

  return (
    <div className="flex items-center gap-2">
      <Label htmlFor="theme-selector" className="sr-only">
        布局
      </Label>
      <Select value={theme} onValueChange={setTheme}>
        <SelectTrigger
          id="theme-selector"
          size="sm"
          className="justify-start *:data-[slot=select-value]:w-12"
        >
          <span className="text-muted-foreground hidden sm:block">布局选择:</span>
          <span className="text-muted-foreground block sm:hidden">布局</span>
          <SelectValue placeholder="布局选择" />
        </SelectTrigger>
        <SelectContent align="end">
          {THEME_OPTIONS.map((theme) => (
            <SelectItem key={theme.name} value={theme.value}>
              {theme.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
